import React, { useEffect, useState } from "react";


import { EyeOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme, ThemeProvider, Container, Typography, useMediaQuery, Box, } from "@mui/material";
import { Form, Input, message, Select } from "antd";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import StickyNote2 from "@mui/icons-material/StickyNote2";
import { Dropdown, Menu, Button, Modal, } from "antd";
import { MoreOutlined } from '@ant-design/icons';


import Sidebars from "../../Components/Sidebar/sidebar";
import '../../css/vehicles.css';
import SearchBar from "../../Components/SearchBar";
import { BorderBottom } from "@mui/icons-material";

import appColors from "../../config/appColors";
import { postRequest } from "../../Api";
import { apiRoutes } from "../../Api/apiRoutes";
import { setLoader } from "../../Redux/Reducers/gernalSlice";
import VehicleView from "../../Components/VehicleView";
import { VEH_AGREEMENT_URL, VEH_IMAGE_URL } from "../../Api/constants";

import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    TextField,
} from '@mui/material';
import AgreementDataTable from "../../Components/AgreementsDataTable";
import AgreementHistoryDrawer from "./AgreementHistoryDrawer";


const { Option } = Select;




const Agreements = () => {



    const { id } = useParams();

    const theme = useTheme();
    const dispatch = useDispatch();

    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')); // Adjust breakpoint as needed
    const user = useSelector((state) => state.authReducer.user);
    const [agreements, setAgreements] = useState([]);
    const [extendModal, setExtendModal] = useState(false);
    const [endDate, setEndDate] = useState();
    const [agreementId, setAgreementId] = useState('');
    const [closeDate, setCloseDate] = useState();
    const [closeModal, setCloseModal] = useState(false);

    const [confirmDelete, setConfirmDelete] = useState(false);
    const [deletedRecord, setDeletedRecord] = useState();
    const [historyOpen, setHistoryOpen] = useState(false);
    const [historyAgreement, setHistoryAgreement] = useState(null);



    const history = useNavigate();


    const getAllAgreements = async () => {

        const onSuccess = (res) => {
            setAgreements(res.data);
        }

        const onError = (err) => {
            console.log('err', err);
        }

        dispatch(setLoader(true));
        const body = {
            token: user?.token
        }

        await postRequest(body, apiRoutes.getAllAgreements, onSuccess, onError)

    }

    const doCloseAgreement = () => {
        if (!closeDate) return message.error("Please select a date");
        setCloseModal(false);
        const onSuccess = (res) => {
            message.success("Agreement closed successfully!");
            setCloseModal(false);
            getAllAgreements();
        }
        const onError = (err) => {
            console.log('err', err);
        }
        dispatch(setLoader(true));
        const body = {
            token: user?.token,
            agreement_id: agreementId,
            end_date: closeDate
        }
        console.log('body__', body);

        postRequest(body, apiRoutes.closeAgreement, onSuccess, onError)
    }

    // const handleActionClick = async (key, record) => {
    //     let status = key == 'approve' ? "approved" : "rejected";
    //     if (status == 'approved') {
    //         const cust_id = record.cust_id ? `/${record.cust_id}` : '';
    //         const veh_id = record.veh_id ? `/${record.veh_id}` : '';

    //         history(`/new-agreement${cust_id}${veh_id}`);
    //         // history(`/generate-agreement/${record.cust_id}/${record.veh_id}`);
    //         // history(`/new-agreement`);
    //         return;
    //     }
    //     const onSuccess = (res) => {

    //         if (status == 'approved') {
    //             history(`/generate-agreement/${record._id}`);
    //             // message.success("Booking request has been approved!");
    //             // dispatch(setLoader(false))
    //         }
    //         else {
    //             message.success("Booking rejected");
    //         }



    //     }
    //     const onError = (err) => {
    //         console.log('err', err)
    //         dispatch(setLoader(false))
    //     }

    //     const body = {
    //         token: user?.token,
    //         booking_id: record._id,
    //         status: status
    //     };
    //     dispatch(setLoader(true))
    //     await postRequest(body, apiRoutes.changeBookingStatus, onSuccess, onError)

    // };


    const onDelete = () => {
        const onSuccess = (res) => {
            setDeletedRecord({});
            message.success("Agreement deleted successfully!");
            getAllAgreements();
        }

        const onError = (err) => {
            message.error(err.data.error);
            console.log('err', err);
        }
        dispatch(setLoader(true));
        const body = {
            token: user?.token,
            agreement_id: deletedRecord.agreement_id,
            parmanent: deletedRecord.parmanent ?? false
        }
        postRequest(body, apiRoutes.deleteAgreement, onSuccess, onError)
    }

    const handleActionClick = async (key, record) => {

        if (key == 'viewNotes') {
            history(`/agreement-notes/${record.agreement_id}`);
        }
        if (key == 'viewHistory') {
            setHistoryAgreement(record);
            setHistoryOpen(true);
        }
        if (key == 'edit') { }
        if (key == 'delete') {
            setDeletedRecord(record);
            setConfirmDelete(true);
        }
        if (key == 'delete_parmanent') {
            setDeletedRecord({ ...record, parmanent: true });
            setConfirmDelete(true);
        }
        if (key == 'extend') {
            setAgreementId(record.agreement_id);
            setExtendModal(true);
        }
        if (key == 'close') {
            setAgreementId(record.agreement_id);
            setCloseModal(true);
        }
        if (key === 'regenerate_agreement') {
            const onSuccess = () => {
                message.success('Success');
            };
            const onError = (err) => {
                message.error(err?.data?.error || 'Request failed');
            };
            dispatch(setLoader(true));
            postRequest(
                { token: user?.token, agreement_id: record.agreement_id },
                apiRoutes.regenerateAgreement,
                onSuccess,
                onError
            );
        }
    };



    const doExtendAgreement = () => {
        if (!endDate) return message.error("Please select a date");
        const onSuccess = (res) => {
            message.success(res?.message || "Agreement extended successfully!");
            setExtendModal(false);
            getAllAgreements();
        }

        const onError = (err) => {
            console.log('err', err);
        }

        dispatch(setLoader(true));
        const body = {
            token: user?.token,
            agreement_id: agreementId,
            extended_date: endDate
        }
        console.log('body__', body);

        postRequest(body, apiRoutes.extendAgreement, onSuccess, onError)
    }




    const columns = [
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',

        },
        {
            title: 'Vehicle name',
            dataIndex: 'veh_name',
            key: 'name',
            render: (text, record) => <Link
                style={{ color: appColors.primary, textDecoration: 'underline', fontFamily: 'Poppins', }}
                to={{
                    pathname: `/vehicle-details/${record?.veh_id}`,
                    state: record,
                }}
            >
                {text}
            </Link>,
        },
        {
            title: 'Customer',
            dataIndex: 'cust_name',
            key: 'cust_name',
            render: (text, record) => <Link
                style={{ color: appColors.primary, textDecoration: 'underline', fontFamily: 'Poppins', }}
                to={{
                    pathname: `/user-details/${record?.cust_id}`,
                    state: record,
                }}
            >
                {record?.name}
            </Link>,
        },
        {
            title: 'Reg no',
            dataIndex: 'reg_no',
            key: 'reg_no',
        },
        {
            title: 'Starting date',
            dataIndex: 'start_date',
            key: 'start_date',
        },
        {
            title: 'Expected End date',
            dataIndex: 'expected_end_date',
            key: 'expected_end_date',
        },

        {
            title: 'Rent',
            dataIndex: 'contract_amount',
            key: 'contract_amount',
        },
        {
            title: 'Initial deposit',
            dataIndex: 'initial_deposit',
            key: 'initial_deposit',
        },

        {
            title: 'Agreement',
            dataIndex: 'phone',
            key: 'phone',
            render: (text, record) => {
                if (record.agreement_path) {
                    return (
                        <div>
                            <a href={VEH_AGREEMENT_URL + record.agreement_path} target="_blank">
                                <EyeOutlined />
                            </a>
                            {/* <Link to={VEH_AGREEMENT_URL + record.agreement_path}>
                                <EyeOutlined />
                            </Link> */}
                        </div>
                    );
                }
            },
        },



        {
            title: 'History',
            dataIndex: 'history_count',
            key: 'history_count',
            render: (text, record) => (
                <button
                    type="button"
                    onClick={() => {
                        setHistoryAgreement(record);
                        setHistoryOpen(true);
                    }}
                    style={{
                        border: 'none',
                        background: 'transparent',
                        color: appColors.primary,
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        fontFamily: 'Poppins',
                        fontSize: 12,
                        padding: 0,
                    }}
                >
                    View ({record.history_count ?? 0})
                </button>
            ),
        },
        {
            title: 'Agreement status',
            dataIndex: 'agreement_status',
            key: 'agreement_status',
            render: (text, record) => <div
                style={{ fontFamily: 'Poppins', fontSize: 12, color: 'black', textTransform: 'capitalize' }}

            >
                {text == 'sign_pending' ? 'Customer sign pending' : text}
            </div>,
        },
        // {
        //     title: 'Extended count',
        //     dataIndex: 'extended_count',
        //     key: 'extended_count',
        // },

        // {
        //     title: 'Extended date',
        //     dataIndex: 'extended_count',
        //     key: 'extended_count',
        // },

        // {
        //     title: 'Agreement type',
        //     dataIndex: 'contract_type',
        //     key: 'contract_type',
        //     render: (text, record) => <div
        //         style={{ fontFamily: 'Poppins', fontSize: 12, color: 'black', textTransform: 'capitalize' }}

        //     >
        //         {text}
        //     </div>,
        // },



        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', }}>
                    {/* <Link
                        to={{
                            pathname: `/add-agreement-note/${record?.agreement_id}`,
                            state: record,
                        }}
                    >
                        <StickyNote2 style={{ marginRight: 10, color: 'black' }} />
                    </Link> */}

                    <Dropdown

                        overlay={

                            <Menu onClick={({ key }) => handleActionClick(key, record)}>
                                {

                                    record?.agreement_status == 'sign_pending' &&
                                    <>
                                        {/* <Menu.Item key="edit">Edit</Menu.Item> */}
                                        <Menu.Item key="regenerate_agreement">Regenerate agreement</Menu.Item>
                                        <Menu.Item key="delete">Delete</Menu.Item>
                                    </>
                                }
                                {

                                    record?.agreement_status == 'deleted' &&
                                    <>
                                        {/* <Menu.Item key="edit">Edit</Menu.Item> */}
                                        <Menu.Item key="delete_parmanent">Delete paramenet </Menu.Item>
                                    </>
                                }
                                {
                                    record?.agreement_status == 'active' &&
                                    <>
                                        <Menu.Item key="close">Close</Menu.Item>
                                        <Menu.Item key="extend">Extend</Menu.Item>
                                        {/* <Menu.Item key="regenerate_agreement">Regenerate agreement</Menu.Item> */}
                                        <Menu.Item key="delete">Delete</Menu.Item>

                                    </>
                                }
                                {/* <Link
                                    to={{
                                        pathname: `/add-agreement-note/${record?.agreement_id}`,
                                        state: record,
                                    }}
                                >
                                    <Menu.Item key="viewNotes">Add note</Menu.Item>
                                </Link> */}
                                <Menu.Item key="viewNotes">View notes ({record.agreement_notes.length}) </Menu.Item>
                                <Menu.Item key="viewHistory">View history ({record.history_count ?? 0})</Menu.Item>
                               
                                {/* <Link
                                    to={{
                                        pathname: `/add-agreement-note/${record?.agreement_id}`,
                                        state: record,
                                    }}
                                >
                                    <Menu.Item key="viewNotes">Add note</Menu.Item>
                                </Link> */}



                            </Menu>

                        }
                        trigger={['click']}
                    >
                        <Button>
                            <MoreOutlined style={{ fontWeight: 'bolder' }} />
                        </Button>
                    </Dropdown>
                </div>
            ),

        },
    ];



    useEffect(() => {
        getAllAgreements()
    }, [])


    return (
        <>
            <ThemeProvider theme={theme}>

                <div style={{ display: 'flex', }}>
                    <Sidebars />
                    <div style={{ marginLeft: 10 }}>
                        <span className={`headertext ${isSmallScreen ? 'small-screen' : ''}`}>
                            Agreements
                        </span>
                        <div>
                            <AgreementDataTable data={agreements} columns={columns} />
                        </div>
                    </div>
                </div>

                <Modal
                    okText="Extend"
                    title="Extend agreement"
                    // visible={extendModal}
                    // visible={extendModal}
                    onOk={doExtendAgreement}
                    onCancel={() => setExtendModal(false)}
                    open={extendModal}
                    onClose={() => setExtendModal(false)}
                    style={{ alignSelf: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', }}
                >
                    <div sx={{ width: "50%", display: 'flex', margin: 'auto', backgroundColor: 'white', height: "20%", paddingRight: 10, paddingLeft: 10 }}>
                        <Form.Item
                            name="agreementEndTime"
                        >
                            <Typography style={labelStyle}>Enter Expected end date</Typography>
                            <Input
                                onChange={(e) => setEndDate(e.target.value)}
                                type="date"
                                value={endDate}
                                // disabled={true}
                                className="textInput"
                            />
                        </Form.Item>
                        <Typography style={{ fontFamily: 'Poppins', fontSize: 12, color: '#666', marginTop: 8 }}>
                            A new PDF will be generated with the new end date. The previous signed PDF will be kept in History.
                        </Typography>
                    </div>
                </Modal>
                <Modal
                    okText="Close"
                    title="Close Agreement"
                    // visible={extendModal}
                    // visible={extendModal}
                    onOk={doCloseAgreement}
                    onCancel={() => setCloseModal(false)}
                    open={closeModal}
                    onClose={() => setCloseModal(false)}
                    style={{ alignSelf: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', }}
                >
                    <div sx={{ width: "50%", display: 'flex', margin: 'auto', backgroundColor: 'white', height: "20%", paddingRight: 10, paddingLeft: 10 }}>
                        <Form.Item
                            name="agreementCloseDate"
                        >
                            <Typography style={labelStyle}>Enter Agreement close date</Typography>
                            <Input
                                onChange={(e) => setCloseDate(e.target.value)}
                                type="date"
                                value={closeDate}
                                // disabled={true}
                                className="textInput"
                            />
                        </Form.Item>
                    </div>
                </Modal>

                <Modal
                    title="Are you sure you want to delete this agreement?"
                    visible={confirmDelete}
                    onCancel={() => setConfirmDelete(false)}
                    footer={[
                        <Button key="cancel" onClick={() => setConfirmDelete(false)}>
                            Cancel
                        </Button>,
                        <Button danger key="delete" onClick={() => {
                            setConfirmDelete(false);
                            onDelete()
                        }}>
                            Delete
                        </Button>,
                    ]}
                >
                    <p>Deleting this agreement will parmanently delete. You will never recover this agreement.</p>
                </Modal>

                <AgreementHistoryDrawer
                    open={historyOpen}
                    onClose={() => {
                        setHistoryOpen(false);
                        setHistoryAgreement(null);
                        getAllAgreements();
                    }}
                    agreement={historyAgreement}
                />




            </ThemeProvider>
        </>
    )

}

const infoContainer = {
    width: 250, borderRadius: 10, backgroundColor: appColors.white, padding: 5, paddingBottom: 20
}

const infoHeadingContainer = {
    width: "100%", backgroundColor: appColors.primaryLight,
    borderTopRightRadius: 10, borderTopLeftRadius: 10,
    height: 40, alignItems: 'center', justifyContent: 'center', display: 'flex'
}

const infoHeading = {
    fontSize: 12, color: appColors.white, fontFamily: 'Poppins', fontWeight: 600
}

const infoValueContainer = {
    display: 'flex', alignItems: 'center', justifyContent: 'center', width: "100%", marginTop: 15,
}

const infoValue = {
    fontSize: 14, color: appColors.black, fontFamily: 'Poppins', fontWeight: 600,
}

const vehicleRowContainer = {
    borderStyle: 'dashed', borderTop: 'none', borderRight: 'none', borderLeft: 'none', borderColor: appColors.grey,
    display: 'flex', flexDirection: 'row', width: "100%", justifyContent: 'space-between', height: 'auto',
    marginTop: 5, paddingBottom: 3

}

const vehicleRow1 = {
    display: 'flex', flexDirection: 'row', width: '48%', justifyContent: 'space-between',
}

const vehicleRow2 = {
    display: 'flex', flexDirection: 'row', width: '48%', justifyContent: 'space-between',
}

const fieldText = {
    fontSize: 12, color: appColors.black, fontFamily: 'Poppins', fontWeight: 600,
}

const valueText = {
    fontSize: 12, color: appColors.greyText, fontFamily: 'Poppins', fontWeight: 600,
}

const labelStyle = { color: appColors.black, fontSize: 14, fontFamily: 'Poppins', marginTop: 0 }

export default Agreements
